import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LocalizeRouterModule, LocalizeParser, LocalizeRouterSettings, ManualParserLoader, CacheMechanism } from 'localize-router';
import { Location, registerLocaleData } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

import localeit from '@angular/common/locales/it';
registerLocaleData(localeit, 'it');
import localeen from '@angular/common/locales/en';
registerLocaleData(localeen, 'en');
import localezh from '@angular/common/locales/zh';
registerLocaleData(localezh, 'zh');
import localefr from '@angular/common/locales/fr';
registerLocaleData(localefr, 'fr');

export function ManualLoaderFactory(translate: TranslateService, location: Location, settings: LocalizeRouterSettings) {
  return new ManualParserLoader(translate, location, settings, ['fr', 'it', 'en', 'zh']);
}

const routes: Routes = [
  {
    path: '',
    canActivate: [],
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    LocalizeRouterModule.forRoot(routes, {
      parser: {
        provide: LocalizeParser,
        useFactory: ManualLoaderFactory,
        deps: [TranslateService, Location, LocalizeRouterSettings]
      },
      cacheMechanism: CacheMechanism.Cookie
    }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
